import React, { useEffect } from "react";
import { useGet, usePost } from "../../common/hooks";
import { Team } from "../../common/interfaces";
import { Button, Form, Input, message } from "antd";
import { getDivisionName } from "../../common/utils";
import Spinner from "../../common/components/Spinner";

interface TeamNameValues {
  teamId: number;
  teamName: string;
}

interface TeamNameFormProps {
  teamId: number;
}

export function TeamNameForm({teamId} : TeamNameFormProps) {
  const teamInfo = useGet<Team>(`/api/team?teamId=${teamId}`);
  const [form] = Form.useForm();
  const updateTeamName = usePost({
    uri: "/api/updateTeamName",
    deps: [teamInfo]
  });

  const onSubmit = (values: TeamNameValues) => {
    form.validateFields()
      .then((validValues: TeamNameValues) => {
        updateTeamName.send({ ...validValues, teamId }, () => {
          message.success("Team name updated.");
        });
      });
  };

  useEffect(() => {
    if (teamInfo.data) {
      // Team.getName() always returns "<teamId> - <customName>" (e.g. "R5 - Cluster Pucks"), so we
      // strip the prefix before putting it in the field; this and the admin edit are the only places
      // we actually care about what the id part is and what the name part is.
      const displayId = `${getDivisionName(teamInfo.data.division)[0]}${teamInfo.data.teamId}`;
      const prefix = `${displayId} - `;
      const formattedName = teamInfo.data.name ?? "";
      const rawName = formattedName.startsWith(prefix) ? formattedName.slice(prefix.length) : "";
      form.setFieldsValue({ teamName: rawName });
    }
  }, [teamInfo.data]);

  if (!teamInfo.data) {
    return <Spinner size={"large"} />;
  }

  const displayId = `${getDivisionName(teamInfo.data.division)[0]}${teamInfo.data.teamId}`;

  return (
    <>
      <Form
        onFinish={onSubmit}
        style={{
          marginTop: 10,
          marginBottom: 10,
          display: "flex",
          alignItems: "center"
        }}
        form={form}
      >
        {displayId} - <Form.Item
            name={"teamName"}
            style={{ marginBottom: 0, marginRight: 10 }}>
          <Input />
        </Form.Item>
        <Button
          type={"primary"}
          disabled={!teamInfo}
          htmlType={"submit"}
          loading={updateTeamName.isLoading}
        >
          Update Team Name
        </Button>
      </Form>
    </>
  );
}
